// extracted by mini-css-extract-plugin
export default {"loader":"page-loader-layer_loader__g3HIG","hidden":"page-loader-layer_hidden__zVxAG"};